import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useState, useEffect } from 'react';
import gtm from '@/utils/gtm';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    const handlePlay = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow 12V 100Ah Lithium Battery | Upgrade for Endless Adventures',
            position: `Product Detail_1`,
        });
    };

    return (
        <div className={styles.TheComp}>
            <div className="img">
                <div id="player-hat1" className="youtube-iframe" onClick={handlePlay}>
                    <iframe className="youtube-iframe" src={`https://www.youtube.com/embed/-ndnP7o5u9I`} />
                </div>
            </div>
        </div>
    );
}
